import { TickCircleSVG } from '../../../svgComponents/tickCircleSVG/index';
import styles from './CheckMarkBulletPoint.module.css';

const CheckMarkBulletPoint = ({
    'data-testid': dataTestId,
    title,
    description
}: {
    'data-testid'?: string;
    title: React.ReactNode;
    description: React.ReactNode;
}) => (
    <p className={styles.CheckMarkBulletPointReason} data-testid={dataTestId}>
        <TickCircleSVG className={styles.CheckMarkBulletPointReasonIcon} />
        <span className={styles.CheckMarkBulletPointReasonInfo}>
            <span className={styles.CheckMarkBulletPointReasonTitle}>
                {title}
            </span>
            <br />
            {description}
        </span>
    </p>
);

// eslint-disable-next-line import/no-default-export
export default CheckMarkBulletPoint;
